export function openInGoogleMaps(startCoordinates = [], endCoordinates = [], openWindowFunction) {
  let url
  const destinationGoogleCoordinates = endCoordinates.slice().reverse().join(',')

  if (startCoordinates.length > 0) {
    const originGoogleCoordinates = startCoordinates.slice().reverse().join(',')

    url = `https://www.google.com/maps/dir/?api=1&origin=${originGoogleCoordinates}&destination=${destinationGoogleCoordinates}&travelmode=driving`
  } else {
    url = `https://www.google.com/maps/dir/?api=1&destination=${destinationGoogleCoordinates}&travelmode=driving`
  }

  openWindowFunction(url)
}

export function openInAppleMaps(startCoordinates = [], endCoordinates = [], openWindowFunction) {
  let url
  const destinationAppleCoordinates = endCoordinates.slice().reverse().join(',')

  if (startCoordinates.length > 0) {
    const originAppleCoordinates = startCoordinates.slice().reverse().join(',')

    url = `http://maps.apple.com/?saddr=${originAppleCoordinates}&daddr=${destinationAppleCoordinates}&dirflg=d`
  } else {
    url = `http://maps.apple.com/?daddr=${destinationAppleCoordinates}&dirflg=d`
  }

  openWindowFunction(url)
}
